import { Employer } from './employer';
import { PropertyViewCard } from './property-view-card';

export class RenewalEmploymentInfo {
    constructor(
        public ResidentKey: number = 0,
        public LeaseRenewalKey: number = 0,
        public LeaseRenewalToken: string = '',
        public AccessToken: string = '',
        public AdditionalIncomeSource: string = '',
        public AdditionalIncomeAmount: number = null,
        public Employments: Employer[] = [],
        public ShowRoommateUpdate: boolean = false,
    ) { }
}
